/**
 * Public storefront URLs, for "view this on the site" links in the panelis.
 *
 * LV is served unprefixed (vinoga.lv/products/x); en/ru are prefixed. The
 * panelis only ever links to the LV page, which is what the shop staff check.
 */

const STOREFRONT_BASE = (
  import.meta.env.VITE_STOREFRONT_URL ?? "https://vinoga.lv"
).replace(/\/+$/, "");

export function storefrontProductUrl(slug: string): string {
  return `${STOREFRONT_BASE}/products/${encodeURIComponent(slug)}`;
}

export function storefrontCategoryUrl(slug: string): string {
  return `${STOREFRONT_BASE}/category/${encodeURIComponent(slug)}`;
}
